/** 上传文件大小限制，单位MB */
export const UPLOAD_LIMIT_SIZE = 5
/** 补充信息上传文件大小限制，单位MB */
export const UPLOAD_ADD_INFO_LIMIT_SIZE = 10
/** 长期有效的截止日期 */
export const EDGE_DATE = '2099-12-31'

export const BusinessLicenseTextConfig = {
	normal: {
		business_license: {
			label: '统一社会信用代码',
			placeholder: '请填写18位统一社会信用代码或15位注册号',
		},
		company_name: {
			label: '公司名称',
			placeholder: '请填写营业执照上的全称',
		},
		address: {
			label: '公司住所',
		},
		license_address: {
			label: '住所详细地址',
			placeholder: '请填写营业执照上的详细地址，需精确到门牌号',
		},
		business_scope: {
			label: '法定经营范围',
		},
	},
	personal: {
		business_license: {
			label: '统一社会信用代码',
			placeholder: '请填写18位统一社会信用代码或15位注册号',
		},
		company_name: {
			label: '字号名称',
			placeholder: '请填写营业执照上的全称',
		},
		address: {
			label: '经营场所',
		},
		license_address: {
			label: '经营场所详细地址',
			placeholder: '请填写营业执照上的详细地址，需精确到门牌号',
		},
		business_scope: {
			label: '经营范围',
		},
	},
}

export const BusinessContactsTextConfig = {
	personal: {
		person_name: {
			label: '经营者姓名',
			placeholder: '请填写营业执照上的姓名',
		},
		person_card_type: {
			label: '经营者证件类型',
		},
		person_mobile: {
			label: '经营者手机号码',
		},
		person_idcard: {
			label: '经营者证件号码',
		},
		idcard_due_url: {
			label: '经营者证件正反面',
		},
		authorize_url: {
			label: '商家入驻确认函',
			tip: `需加盖公章，支持jpg或png格式，最大不超过${UPLOAD_LIMIT_SIZE}M，请确保照片清楚，文字可辨识，上传后可点击缩略图查看大图`,
		},
	},
	normal: {
		person_name: {
			label: '法定代表人姓名',
			placeholder: '请填写营业执照上的法定代表人',
		},
		person_card_type: {
			label: '法定代表人证件类型',
		},
		person_mobile: {
			label: '法定代表人手机号',
		},
		person_idcard: {
			label: '法定代表人证件号码',
		},
		idcard_due_url: {
			label: '法定代表人证件正反面',
		},
		authorize_url: {
			label: '授权委托书',
			tip: `由公司出具的授权业务联系人办理入驻操作的授权委托书，需加盖公章，支持jpg或png格式，最大不超过${UPLOAD_LIMIT_SIZE}M，请确保照片清楚，文字可辩识，上传后可点击缩略图查看大图`,
		},
	},
	artist: {
		person_name: {
			label: '姓名',
			placeholder: '请填写姓名',
		},
		person_mobile: {
			label: '本人手机号',
		},
		person_card_type: {
			label: '证件类型',
		},
		person_idcard: {
			label: '证件号码',
		},
		idcard_due_url: {
			label: '证件正反面',
		},
		authorize_url: {
			label: '履约承诺函',
			tip: `支持jpg或png格式，最大不超过${UPLOAD_LIMIT_SIZE}M，请确保照片清楚，文字可辨识，上传后可点击缩略图查看大图`,
		},
	},
}

export const StepsFourTextConfig = {
	normal: {
		collect_name: {
			label: '对公账户开户名',
		},
		bank_account: {
			label: '对公银行账号',
		},
		amount: {
			label: '对公银行账号验证',
			placeholder: '请输入对公银行账号内收到的金额(元)',
		},
		bank_account_url: {
			label: '对公银行账户信息证明',
			tip:
				`支持jpg或png格式，大小不超过${UPLOAD_LIMIT_SIZE}M。请确保照片清楚，文字可辨识，有彩色企业公章，上传后可点击查看大图。`,
		},
	},
	personal: {
		collect_name: {
			label: '字号名称',
		},
		bank_account: {
			label: '经营者银行账号',
		},
		amount: {
			label: '银行账号验证',
			placeholder: '请输入银行账号内收到的金额(元)',
		},
		bank_account_url: {
			label: '对公银行账户信息证明',
			tip:
				`支持jpg或png格式，大小不超过${UPLOAD_LIMIT_SIZE}M。请确保照片清楚，文字可辨识，有彩色企业公章，上传后可点击查看大图。`,
		},
	},
	artist: {
		collect_name: {
			label: '银行开户名',
		},
		bank_account: {
			label: '银行账号',
		},
		amount: {
			label: '银行账号验证',
			placeholder: '请输入银行账号内收到的金额(元)',
		},
		bank_account_url: {
			label: '银行卡正面照片',
			tip:
				`支持jpg或png格式，大小不超过${UPLOAD_LIMIT_SIZE}M。请确保照片清楚，文字可辨识，上传后可点击查看大图。`,
		},
	},
}
